import React from 'react';
import './aiImprove.css';

/**
 * Gmail Gemini-style floating pill near the caret.
 */
export default function AIFloatingButton({
  visible = false,
  top = 0,
  left = 0,
  onClick,
  disabled = false,
}) {
  if (!visible) return null;

  return (
    <button
      type="button"
      className="aii-float-btn"
      style={{ top, left }}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      disabled={disabled}
      aria-label="Improve with AI"
    >
      <span className="aii-float-sparkle" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2l1.35 4.15L17.5 7.5l-4.15 1.35L12 13l-1.35-4.15L6.5 7.5l4.15-1.35L12 2z" />
        </svg>
      </span>
      <span>Improve with AI</span>
    </button>
  );
}
